import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchUserSuccess,
  fetchUserFailure,
  updateUserSuccess,
  updateUserFailure,
} from "../ProfileUpdate/profileUpdateAction";
import { FETCH_USER_REQUEST, UPDATE_USER_REQUEST } from "./profileUpdateTypes";
import axiosInstance from "../instance/AxiosInstance";

function* fetchUserSaga(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/user/getuser/${action.payload}`
    );

    yield put(fetchUserSuccess(response.data));
  } catch (error) {
    yield put(fetchUserFailure(error.message));
  }
}

function* updateUserSaga(action) {
  try {
    const response = yield call(
      axiosInstance.put,
      `/user/updateuser/${action.payload.id}`,
      action.payload
    );

    yield put(updateUserSuccess(response.data.message));
  } catch (error) {
    yield put(updateUserFailure(error.message));
  }
}

export default function* updateProfileSaga() {
  yield takeLatest(FETCH_USER_REQUEST, fetchUserSaga);
  yield takeLatest(UPDATE_USER_REQUEST, updateUserSaga);
}
